import {Fragment, useState} from "react";
import * as React from "react";
import {Link, useNavigate} from "react-router-dom";
import {UserType} from "../../service/Enums";
import axios from "axios";
import {CToast, CToastBody} from "@coreui/react";
import Form from "react-bootstrap/Form";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Button from '@mui/material/Button';
import {Box, CircularProgress} from "@mui/material";
import {API_URL} from "../../utils/constants";
import {useToast} from "../../Context/ToastContext";

export const InscriptionAgenceAdmin = ({onClose, onSuccess, isModal = false}) => {

    const INITIAL_STATE = {
        username: "",
        firstname: "",
        email: "",
        password: ""
    }

    const [hasError, setHasError] = useState(false);
    const [mailError, setMailError] = useState();
    const [erreur, setErreur] = useState('');
    const [modal, setModal] = useState({
        show: false,
        title: "",
        content: [""],
        error: false
    });
    // States for registration
    const [form, setForm] = React.useState(INITIAL_STATE);
    const [loading, setLoading] = useState(false);
    // States for checking the errors
    const [submitted, setSubmitted] = React.useState(false);
    const [error, setError] = React.useState(false);

    /*** password toogle hide show */
    const [passwordType, setPasswordType] = useState("password");

    const toaster = useToast();

    const showMessage = (arg) => {


        setModal(arg);
        if (!arg.error) {
            // navigate("/");
        }
    }
    const navigate = useNavigate();


    const handleChange = (event) => {
        let val = (event.target.type === "checkbox") ? event.target.checked : event.target.value;
        handleFieldChange(event.target.name, val === "" ? INITIAL_STATE[event.target.name] : val);
    };

    const handleFieldChange = (field, value) => {
        setForm({
            ...form,
            [field]: value
        });
    }

    // Handling the form submission
    const handleSubmit = (e) => {
        setLoading(true);
        e.preventDefault();


        if (form.username === '' || form.email === '' || form.password === '' || form.firstname === '') {
            setError(true);
            setSubmitted(false);
            setLoading(false); // Arrêter le chargement ici
        } else {
            setLoading(true); // Commencer le chargement si le formulaire est valide
            save({
                ...form,
                username: `${form.username}`.toLowerCase(),
            });
        }
    };

    const save = (payload) => {
        payload = {
            userInformation: {
                ...payload,
                userType: UserType.ADMIN.value,
            }
        }

        axios
            .post(`${API_URL}/register`, payload)
            .then((res) => {
                setLoading(false);
                if (!res.data.error) {
                    toaster.notifySuccess("Administrateur créé avec succès");
                    setSubmitted(true);
                    setError(false);
                    if (onSuccess) {
                        onSuccess();
                    }
                    if (onClose) {
                        onClose();
                    }
                } else {
                    let errorMessage = 'Une erreur est survenue lors de la création de l\'administrateur d\'agence.';
                    if (res.data.message) {
                        if (res.data.message.includes('email')) {
                            errorMessage = 'Cette adresse email est déjà utilisée.';
                        } else if (res.data.message.includes('username')) {
                            errorMessage = 'Ce nom d\'utilisateur est déjà pris.';
                        } else if (res.data.message.includes('agency')) {
                            errorMessage = 'Une agence avec ce nom existe déjà.';
                        } else {
                            errorMessage = res.data.message;
                        }
                    }
                    setMailError(errorMessage);
                    showMessage({
                        show: true,
                        title: "Erreur",
                        content: [errorMessage],
                        error: true,
                    });
                }
            })
            .catch((err) => {
                let errorMessage = 'Une erreur est survenue lors de la création de l\'administrateur d\'agence.';

                if (err.response?.data?.message) {
                    if (err.response.data.message.includes('email')) {
                        errorMessage = 'Cette adresse email est déjà utilisée.';
                    } else if (err.response.data.message.includes('username')) {
                        errorMessage = 'Ce nom d\'utilisateur est déjà pris.';
                    } else if (err.response.data.message.includes('agency')) {
                        errorMessage = 'Une agence avec ce nom existe déjà.';
                    } else {
                        errorMessage = err.response.data.message;
                    }
                }

                setMailError(errorMessage);
                toaster.notifyError(errorMessage);
                setHasError(true);
                setErreur(err);
                setLoading(false);
            });
    };

    let emailMessage = () => {
        console.log("emailErr", error);
        return (
            <Fragment>
                <div className="error" style={{display: error ? "" : "none"}}>
                    {form.email === "" && !mailError && (
                        <span style={{color: "red"}}>
              Veuillez entrer votre adresse e-mail.
            </span>
                    )}
                </div>
                <div className="error"
                     style={!isEmailValid && form.email !== "" && !mailError ? {display: "block"} : {display: "none"}}>
                    {!isEmailValid && form.email !== "" && !mailError && (
                        <span style={{color: "red"}}>
              Veuillez entrer une adresse e-mail valide.
            </span>
                    )}
                </div>
                <div className="error"
                     style={mailError === "\"email\" must be a valid email" && form.email !== "" ? {display: "block"} : {display: "none"}}>
                    {mailError === "\"email\" must be a valid email" && form.email !== "" && (
                        <span style={{color: "red"}}>
              Veuillez entrer un adresse email Valide
            </span>
                    )}
                </div>
            </Fragment>
        );
    };

    let emailErrorMessage = null;

    if (hasError) {
        // Logique pour déterminer si l'erreur côté client doit être affichée
        emailErrorMessage = () => {
            if (
                erreur &&
                erreur.response &&
                erreur.response.data &&
                erreur.response.data.data &&
                erreur.response.data.data.details
            ) {
                const isEmailError = erreur.response.data.data.details.some((detail) => {
                    if (typeof detail === "string") {
                        return detail.includes("email");
                    } else if (typeof detail === "object" && detail !== null) {
                        // Gérer le cas où detail est un objet
                        // Par exemple, vérifier une propriété spécifique dans l'objet
                        // ou appliquer une logique appropriée selon vos besoins
                        // Ici, vous pouvez retourner false ou true selon votre logique
                        return false;
                    } else {
                        // Gérer les autres cas si nécessaire
                        return false;
                    }
                });

                return (
                    isEmailError && (
                        <div className="error">
            <span style={{color: "red"}}>
              {erreur.response.data.data.details.map((detail) => (
                  <span key={detail.message}>{detail.message ?? detail}</span>
              ))}
            </span>
                        </div>
                    )
                );
            }
        };
    } else {
        emailErrorMessage = emailMessage;
    }

    const isUsernameValid = form.username.length >= 3;

    let usernameMessage = () => {
        return (
            <Fragment>
                <div className="error" style={{display: error ? "" : "none"}}>
                    {form.username === "" && (
                        <span style={{color: "red"}}>
                Veuillez entrer votre pseudo.
              </span>
                    )}
                </div>
                <div className="error"
                     style={!isUsernameValid && form.username !== "" ? {display: "block"} : {display: "none"}}>
                    {!isUsernameValid && form.username !== "" && (
                        <span style={{color: "red"}}>
                Le pseudo doit comporter 3 caractères au minimum
              </span>
                    )}
                </div>
            </Fragment>
        );
    }
    let usernameErrorMessage = null;


    if (hasError) {
        usernameErrorMessage = () => {
            // Vérifier si erreur et erreur.response sont définis avant d'accéder à leurs propriétés
            if (
                erreur &&
                erreur.response &&
                erreur.response.data &&
                erreur.response.data.data &&
                erreur.response.data.data.details
            ) {
                const isPseudoError = erreur.response.data.data.details.some(
                    (detail) => {
                        if (typeof detail === "string") {
                            return detail.includes("pseudo");
                        } else if (typeof detail === "object" && detail !== null) {
                            // Gérer le cas où detail est un objet
                            // Par exemple, vérifier une propriété spécifique dans l'objet
                            // ou appliquer une logique appropriée selon vos besoins
                            // Ici, vous pouvez retourner false ou true selon votre logique
                            return false; // Par exemple, retourne false si l'objet ne contient pas d'erreur pseudo
                        } else {
                            // Gérer les autres cas si nécessaire
                            return false; // Par exemple, retourne false pour tout autre type de détail
                        }
                    }
                );
                return (
                    isPseudoError && (
                        <div className="error">
              <span style={{color: "red"}}>
                {erreur.response.data.data.details.map((detail) => (
                    <span key={detail.message}>{detail.message ?? detail}</span>
                ))}
              </span>
                        </div>
                    )
                );
            }
        };
    } else {
        // S'il n'y a pas d'erreur côté serveur, afficher l'erreur côté client
        usernameErrorMessage = usernameMessage;
    }
    ;

    const SuccesToast = (
        <CToast title="Bootstrap React">
            <CToastBody>
                <p className='text-green'>
                    Utilisateur {form.username} enregistré avec succès!!
                </p>
            </CToastBody>
        </CToast>
    )
    const errorToast = (
        <CToast title="Bootstrap React"
                style={mailError === "\"email\" must be a valid email" ? {display: 'block'} : {display: 'none'}}>
            <CToastBody>
                <p className='error'>
                    {mailError === "\"email\" must be a valid email" ? (
                        <span style={{color: "red"}}>
             Erreur: Veuillez entrer un adresse email Valide
            </span>
                    ) : ""}
                </p>
            </CToastBody>
        </CToast>
    )
    // Showing success message
    const successMessage = () => {
        return (
            <div
                className="success"
                style={{
                    display: submitted ? '' : 'none',
                }}>
                <h1>Utilisateur {form.username} enregistré avec succès!!</h1>
            </div>
        );
    };

    // Showing error message if error is true
    const isEmailValid = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(
        form.email
    );
    const isPasswordValid =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,}$/.test(
            form.password
        );

    const passwordMessage = () => {
        console.log("error2", error);
        return (
            <Fragment>
                <div className="error" style={{display: error ? "" : "none"}}>
                    {form.password === "" && (
                        <span style={{color: "red"}}>
              Veuillez entrer votre mot de passe.
            </span>
                    )}
                </div>
                <div className="error"
                     style={!isPasswordValid && form.password !== "" ? {display: "block"} : {display: "none"}}>
                    {!isPasswordValid && form.password !== "" && (
                        <span style={{color: "red"}}>
              Le mot de passe doit comporter au moins 8 caractères : une
              minuscule, une majuscule, un chiffre et un caractère spécial.
            </span>
                    )}
                </div>
            </Fragment>
        );
    };

    const isFirstnameValid = form.firstname.length >= 3;
    const firstnameMessage = () => {
        return (
            <Fragment>
                <div className="error" style={{display: error ? "" : "none"}}>
                    {form.firstname === "" && (
                        <span style={{color: "red"}}>Veuillez entrer votre prénom.</span>
                    )}
                </div>
                <div className="error"
                     style={!isFirstnameValid && form.firstname !== "" ? {display: "block"} : {display: "none"}}>
                    {!isFirstnameValid && form.firstname !== "" && (
                        <span style={{color: "red"}}>
              Le prénom doit comporter 3 caractères au minimum
            </span>
                    )}
                </div>
            </Fragment>
        );
    };

    /*** style variable ***/

    const InputedStyle = {
        height: "37px",
        backgroundColor: "#F3F7F9",
        border: "1px solid rgba(217, 217, 217, 0.35)",
        borderRadius: "5px",
    };
    const fontWeightTitle = {
        fontWeight: "600"
    };
    const connexionBtn = {
        height: "40px",
        background: "#1B208C",
        color: "#fff",
        borderRadius: "8px",
        border: "none"
    }


    // const handlePasswordChange = (evnt) => {
    //   setPasswordInput(evnt.target.value);
    // }
    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text")
            return;
        }
        setPasswordType("password")
    }

    return (
        <>
            {!isModal ? (
                <legend className="mb-3 mt-3" style={fontWeightTitle}>
                    S'inscrire
                </legend>) : (
                <legend className="mb-3 mt-3" style={fontWeightTitle}>
                    Ajouter un administrateur
                </legend>)
            }
            <Form>

                <Form.Group className="mb-3" controlId="username">
                    <Form.Label
                        style={Object.assign(fontWeightTitle, {
                            display: "block",
                        })}
                    >
                        Votre pseudo (Login) *
                    </Form.Label>
                    <Form.Control
                        onChange={handleChange}
                        className="input"
                        type="text"
                        placeholder="pseudo"
                        name="username"
                        style={InputedStyle}
                    />
                    {hasError && !error && usernameErrorMessage()}
                    {(error || !hasError) && usernameMessage()}
                </Form.Group>

                <Form.Group className="mb-3" controlId="password">
                    <Form.Label
                        style={Object.assign(fontWeightTitle, {
                            display: "block",
                        })}
                    >
                        Mot de passe *
                    </Form.Label>
                    <div
                        className="input d-flex align-items-center  ps-0"
                        style={InputedStyle}
                    >
                        <Form.Control
                            onChange={handleChange}
                            className="input border-0"
                            type={passwordType}
                            placeholder="mot de passe"
                            name="password"
                            style={InputedStyle}
                        />
                        <p
                            className="btn border-0 outline-0 bg-transparent mb-0"
                            onClick={togglePassword}
                        >
                            {passwordType === "password" ? (
                                <VisibilityOffIcon/>
                            ) : (
                                <VisibilityIcon/>
                            )}
                        </p>
                    </div>
                    {passwordMessage()}
                </Form.Group>

                <Form.Group className="mb-4" controlId="firstname">
                    <Form.Label
                        style={Object.assign(fontWeightTitle, {
                            display: "block",
                        })}
                    >
                        Votre prénom *
                    </Form.Label>
                    <Form.Control
                        onChange={handleChange}
                        className="input"
                        type="text"
                        placeholder="prénom"
                        name="firstname"
                        style={InputedStyle}
                    />
                    {firstnameMessage()}
                </Form.Group>

                <Form.Group className="mb-3" controlId="email">
                    <Form.Label
                        style={Object.assign(fontWeightTitle, {
                            display: "block",
                        })}
                    >
                        E-mail *
                    </Form.Label>
                    <Form.Control
                        onChange={handleChange}
                        className="input"
                        type="text"
                        placeholder="e-mail"
                        name="email"
                        style={InputedStyle}
                    />
                    {hasError && !error && emailErrorMessage()}
                    {(error || !hasError) && emailMessage()}
                </Form.Group>
                <Form.Group className="mb-3">
                    <Button
                        onClick={handleSubmit}
                        className="w-100 mb-2"
                        style={Object.assign(connexionBtn, fontWeightTitle)}
                        disabled={loading}
                    >
                        {loading ? <CircularProgress/> : "Enregistrer"}
                    </Button>
                </Form.Group>
            </Form>
            {!isModal && (
                <div className="d-flex w-100 justify-content-center mb-3">
                    <Link className=" text-black" as={Link} to="/">
                        Se connecter ?
                    </Link>
                </div>
            )}
        </>

    );
}